import { BARE_LES_NAR_VALGT, KUN_LESING, PAKREVET_HVIS_FORELDER, SPORSMAL_PAKREVET } from '../../constants/general';

export function IsSubQuestionAndShouldNotRender(context, question) {
    const { rootQuestion, requiredParent: requiredAnswers, isSubQuestion } = question;

    if (!isSubQuestion) {
        return false;
    }

    const rootQuestionAnswers = context.getValue(rootQuestion);
    return !rootQuestionAnswers.includes(requiredAnswers);
}

export function isRequiredWhenSelected({ utfyllingsregel }) {
    return utfyllingsregel && (utfyllingsregel.regel === BARE_LES_NAR_VALGT || utfyllingsregel.regel === KUN_LESING);
}

export function isRequiredQuestion(utfyllingsregel) {
    return (
        utfyllingsregel &&
        [SPORSMAL_PAKREVET, BARE_LES_NAR_VALGT, PAKREVET_HVIS_FORELDER].includes(utfyllingsregel.regel)
    );
}

export function getPreselected(question) {
    return question.muligeSvar.find((q) => q.valgt);
}

export const getCitizenshipList = (countries, excludedCitizenship) => {
    return excludedCitizenship && excludedCitizenship !== ''
        ? countries.filter((country) => country.value !== excludedCitizenship)
        : countries;
};
